export default __webpack_public_path__ + "static/media/Support_Active.e8d0efd1.svg";